module.exports = __webpack_public_path__ + "img/skinbox-white.a498bc14.png";